// extracted by mini-css-extract-plugin
module.exports = {"next":"blxQ6pHc","prev":"QkAFrhl6","icon":"U0_KyO2D","label":"ezoTeEiF"};